module.exports = __webpack_public_path__ + "static/share-of-amazon-f4566e34e3dc803a791248b78e69e934.png";